import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';

import { Box as MuiBox } from '@mui/system';

import TextField from './TextField';
import DeleteButton from 'components/Buttons/DeleteButton';
import { useTranslation } from 'react-i18next';

const FormTextField = styled((props) => {
  const { t } = useTranslation();
  // Destructure data-testid to prevent it from being spread to wrapper.
  // `parse` is an optional value transformer applied on change (e.g. force
  // uppercase / transliterate) — destructured so it is NOT spread onto the DOM.
  const {
    'data-testid': dataTestId,
    onDelete,
    withDeleteButton,
    parse,
    ...restProps
  } = props;
  return (
    <Field
      data-id={props.name}
      name={props.name}
      initialValue={props.initialValue}
    >
      {({ input, meta }) => (
        <MuiBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            gap: 1,
          }}
        >
          <TextField
            {...restProps}
            {...input}
            autoComplete="off"
            onKeyDown={
              props.type === 'number'
                ? (evt) =>
                  ['e', 'E', '+', '-'].includes(evt.key) &&
                  evt.preventDefault()
                : props.dataId === 'zipcode' ?
                  ((evt) => {
                    // allow only numbers and and dash
                    // disable all characters and special characters
                    // Allow only numbers, dash, backspace, and delete for zipcode
                    const charCode = evt.key;
                    const allowedPattern = /^[0-9\-]+$/; // Regular expression for numbers and dash
                    const isControlKey =
                      evt.keyCode === 8 || evt.keyCode === 46; // Backspace or Delete

                    if (!charCode.match(allowedPattern) && !isControlKey) {
                      evt.preventDefault();
                    }
                  }) : undefined
            }
            onChange={(e) => {
              const nextValue =
                props.type === 'number' &&
                props.dataId !== 'zipcode' &&
                e.target.value !== '' // This allows to clear input completely instead of leaving unclearable 0
                  ? +e.target.value
                  : e.target.value;
              input.onChange(parse ? parse(nextValue) : nextValue);
            }}
            variant="outlined"
            size="small"
            data-id={props.dataId || 'form-text-field'}
            inputProps={{
              ...props.inputProps,
              'data-testid': dataTestId
            }}
            error={!!((meta.touched || meta.submitFailed) && (meta.error || meta.submitError))}
            helperText={(meta.touched || meta.submitFailed) && (t(meta.error) || t(meta.submitError))}
          />
          {props?.withDeleteButton && (
            <DeleteButton disabled={props.disabled} onClick={props.onDelete} />
          )}
        </MuiBox>
      )}
    </Field>
  );
})`

  && {
    margin-bottom: ${(props) => props.mb || 0}px;
    width: 100%;
    .formControl {
      padding-top: ${(props) => props.multiline && '6px'};
      padding-bottom: ${(props) => props.multiline && '6px'};
      height: ${(props) => (props.multiline ? 'auto' : '40px')};
    }
    .input {
      height: ${(props) => (props.multiline ? 'auto' : '40px')};
      min-height: ${(props) => `${props.$minHeight}px` || '40px'};
      max-height: 300px;
      /* border-color: ${({ theme }) => theme.palette.colors.gray200}; */
    }
    fieldset {
      /* border-color: ${({ theme }) => theme.palette.colors.gray200}; */
    }
    .MuiOutlinedInput-root.Mui-disabled {
      background-color: ${({ theme }) => theme.palette.colors.gray100 || '#f9f9f9'};
      .MuiOutlinedInput-notchedOutline {
        border-color: ${({ theme }) => theme.palette.colors.gray200 || '#eeeeee'};
      }
      .MuiInputBase-input {
        color: ${({ theme }) => theme.palette.colors.black100};
        -webkit-text-fill-color: ${({ theme }) => theme.palette.colors.black100};
        cursor: not-allowed;
      }
    }
  }
`;

export default FormTextField;
